var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('quoteBasic',{attrs:{"title":'Refer Dealer Leads',"propsMode":'new',"quoteType":'leads',"leadSource":'RDL'}})}
var staticRenderFns = []

export { render, staticRenderFns }